// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3FQnF","image":"Header_image__2w22n","name":"Header_name__2kfvQ","info":"Header_info__3a7iy","infoRow":"Header_infoRow__1uT8Y"};